const play = () => import('@/page/play')
export default [{
  path: '/play',
  name: 'play',
  component: play,
  childred: []
}]


// WEBPACK FOOTER //
// ./src/router/play/index.js